import { Tab, Tabs } from "@mui/material"
import { type FC, useState } from "react"
import { BetaTag } from "../components/BetaTag"
import { ContactList } from "../components/Cop/ContactList"
import { NodeList } from "../components/Cop/NodeList"
import { OperationList } from "../components/Cop/OperationList"
import { SensorList } from "../components/Cop/SensorList"
import { UnitList } from "../components/Cop/UnitList"
import { MainContent } from "../components/MainContent"
import { PageContainer } from "../components/PageContainer"

export const CopPage: FC = () => {
  const [tab, setTab] = useState(0)

  return (
    <MainContent
      headerProps={{
        title: (
          <>
            Update COP <BetaTag />
          </>
        ),
        documentTitle: "Update COP",
      }}
    >
      <PageContainer>
        <Tabs value={tab} onChange={(_, v: number) => setTab(v)} sx={{ mb: 2 }}>
          <Tab label="Nodes" />
          <Tab label="Sensors" />
          <Tab label="Contacts" />
          <Tab label="Operations" />
          <Tab label="Units" />
        </Tabs>
        {tab === 0 && <NodeList />}
        {tab === 1 && <SensorList />}
        {tab === 2 && <ContactList />}
        {tab === 3 && <OperationList />}
        {tab === 4 && <UnitList />}
      </PageContainer>
    </MainContent>
  )
}
